import LegacyBreadcrumb from './LegacyBreadcrumb';

export * from './LegacyBreadcrumb';

export default LegacyBreadcrumb;
